import { useContext } from 'react'

import CreateApiClientContext from '@dc-shared-web/providers/CreateApiClientContext'

const { Provider, context } = CreateApiClientContext({})

export const SvcCrunchesProvider = Provider

export const useSvcCrunchesContext = () => useContext(context)
